<template>
  <div :style="{direction:$t('direction')}">

    <Header></Header>

      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-6 col-sm-12">
          
          <div class="my-4">
            <h3 class="p-3">آموزش احراز هویت در ارزینه</h3>

            <video width="100%" controls>
              <source :src="StaticImageUrl+'assets/videos/auth.mp4'" type="video/mp4">
              Your browser does not support the video tag.
            </video> 
          </div>
          <hr>
          <div class="my-4">
            <h3 class="p-3">آموزش خرید و فروش فوری</h3>

            <video width="100%" controls>
              <source :src="StaticImageUrl+'assets/videos/fastbuy-sale.mp4'" type="video/mp4">
              Your browser does not support the video tag.
            </video> 
          </div>

        </div>
      </div>

    <Footer></Footer>
  </div>
</template>
<script>
import Header from './Header'
import Footer from './Footer'
// import {io} from 'socket.io-client';
export default {
  name: 'Tutorial',
  components:{
    Header,
    Footer
  },
  data(){
    return{
      prices:{},
      data:null,
      socket : null,
    }
  },
  methods:{
  },
  created() {

    // this.socket = io(this.socketUrl);

  },
  mounted() {
    this.activeLoading(false)
  },
  beforeMount() {
    window.scrollTo(0, 0);
  }
}
</script>
